import { auditReports } from '@mi-front/api-clients';
import { ComponentType } from 'react';
import { GipAltReportDetail } from '../gip/gip-alt-report/view/GipAltReportDetail';
import { GipReportDetail } from '../gip/gip-report/view/GipReportDetails';

export const VIEW_MAP: Record<string, ComponentType<{ report: any }>> = {
  [auditReports.GipReportDtoTypeEnum.AUDIT_GIP_STATUS]: GipReportDetail,
  [auditReports.GipAltReportDtoTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT]: GipAltReportDetail,
};
